require('./new.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/form/form-module')

# Load Css
require('../../../sass/web/session/_session.scss')

SessionNewCtrl = require('./new-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-auth'
  'gnp-form'
  'gnp-common-wrapper'
  'gnp-error-handler'
]
angular.module "gnp-app-session", modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/session/new',
      templateUrl: 'web/session/new.jade'
      controller: 'SessionNewCtrl'
      title: '_SESSION.NEW.TITLE'
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'SessionNewCtrl', SessionNewCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/session/session-module.coffee